import { render, staticRenderFns } from "./low-busbar.vue?vue&type=template&id=d12f3cb6&scoped=true"
import script from "./low-busbar.vue?vue&type=script&lang=js"
export * from "./low-busbar.vue?vue&type=script&lang=js"
import style0 from "./low-busbar.vue?vue&type=style&index=0&id=d12f3cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12f3cb6",
  null
  
)

export default component.exports